import { Timestamp } from 'firebase/firestore';

export interface Product {
    article_number: number,
    image: number,
    measurement: string,
    name: string,
    dimension: string
}

export interface ShoppingCart {
    initiator: string,
    project: string,
    products: ShoppingCartProduct[]
}

export interface ShoppingCartProduct {
    amount: number,
    timestamp: Timestamp,
    product: Product
}

// 2. Model Classes (implementing the interfaces)
export class ShoppingCartModel implements ShoppingCart {
    initiator: string;
    products: ShoppingCartProduct[];
    project: string;

    constructor(data: ShoppingCart) {  // Constructor takes the interface type
        this.initiator = data.initiator;
        this.products = data.products.map(product => new ShoppingCartProductModel(product)); // Important: Map to model class
        this.project = data.project
    }
}

export class ShoppingCartProductModel implements ShoppingCartProduct {
    amount: number;
    timestamp: Timestamp;
    product: Product;  // Or ProductModel if you have one


    constructor(data: ShoppingCartProduct) {
        this.amount = data.amount;
        this.timestamp = data.timestamp;
        this.product = data.product; // Or new ProductModel(data.product) if you have a ProductModel
    }

}

export class ProductModel implements Product{
    article_number: number;
    image: number;
    measurement: string;
    name: string;
    dimension: string;

    constructor (data: Product) {
        this.article_number = data.article_number
        this.image = data.image
        this.measurement = data.measurement
        this.name = data.name
        this.dimension = data.dimension
    }
}